import React from 'react';
import cn from 'classnames';
import type { FC } from 'react';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';

import { useStockExchange } from '../../../hooks/use-stock-exchange';
import type { IInvestMediaportalMarketQuotationsProps } from '../../../models';
import { QuotationCardDesktop } from '../../../components/quotation-card/desktop/component';

import styles from './styles.css';

export const InvestMediaportalMarketQuotationsDesktop: FC<
    IInvestMediaportalMarketQuotationsProps
> = ({ assets, className }) => {
    const [{ data, isLoading }] = useStockExchange(assets);

    return (
        <section className={cn(className, styles.external, styles.section)}>
            <Block className={cn(styles.external, styles.block)} notPadded>
                {data.map(item => {
                    return (
                        <QuotationCardDesktop
                            key={item.isin}
                            imageSrc={item.imageSrc}
                            isLoading={isLoading}
                            name={item.name}
                            pricePercentChange={item.pricePercentChange}
                            trend={item.trend}
                        />
                    );
                })}
            </Block>
        </section>
    );
};
